
import React, { useEffect, useState } from 'react';
import {SvgEdit, SvgDelete, SvgNew2, Valorbr2, SvgSairMenu} from "../../Svg.js"
import FForm from './Form.js';

function AnuGrid() {
  const [tabela, setTabela] = useState([]);
  const [opcAI,  setopcAI] = useState(""); 
  const [opcId,  setopId] = useState(""); 
  const [titulo, setTitulo] = useState(""); 
  const [PopExcluir, setPopExcluir] = useState(false); 
  const [itemToDelete, setItemToDelete] = useState(null); 
  const handleDeleteClick = (id) => {
    setItemToDelete(id); 
    setPopExcluir(true);  
  };

  const confirmDelete = () => {
    console.log(`Excluindo item com id: ${itemToDelete}`);
    setTabela((prevState) => prevState.filter((item) => item.id !== itemToDelete)); // Remove o item da tabela
    handleDelete(itemToDelete);
    setPopExcluir(false);  
  };

  const cancelDelete = () => {
    setPopExcluir(false); 
  };

  const handleDelete = async (id) => {
    try {
      const response = await fetch(`http://localhost:3001/cr_pag_Id/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({}), 
      });
      if (response.status === 200) {
        //navigate(0);
      } else {
        console.error('Erro ao deletar cliente:', response.status);
        alert('Erro ao deletar Cr_Pag.'+response.status);
      }
    } catch (error) {
      console.error('Erro na requisição:', error);
      alert('Erro no servidor.', error);
    }

  }


  const [PopAlterar, setPopAlterar] = useState(false); 

  const handleAlterClick = (id, ai) => {
    setTitulo("Alterar");
    setopcAI(ai);
    setopId(id);
    setPopAlterar(true);  
  };
      
  const handleIncluirClick = (id, ai) => {
    setTitulo("Incluir");
    setopcAI(ai);
    setopId(id);
    setPopAlterar(true);  
  };
      
  useEffect(() => {
    fetch('http://localhost:3001/cr_anu')
      .then((response) => {
        if (!response.ok) {
          throw new Error('Erro na resposta da API');
        }
        return response.json();
      })
      .then((data) => {
        console.log("Dados da API:", data);
        //alert(JSON.stringify(data)); // Agora exibe os dados corretamente
        setTabela(data.cr_anu);
      })
      .catch((error) => console.error('Erro ao buscar os dados:', error));
  }, []); 


return (
  
  <div id = "texto2"> 
    <h3>Anúncios</h3><br/>
    <div id="Fecha" onClick={() => {window.location.href = "./area"; }}>X</div>
    <table class="tableGrid">
      <thead>
        <tr>
          <th>Chave</th>
          <th>Identificacao</th>
          <th>Valor</th>
          <th>Aplicar</th>
          <th>Ativo</th>
          <th>&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        {tabela.map((itens) => (
          <tr key={itens.chave}>
            <td>{itens.chave}</td>
            <td>{itens.identificacao}</td>
            <td class="thdireito">{Valorbr2(itens.valor)}</td>
            <td>{itens.aplicarno}</td>
            <td>{itens.ativo ? 'Sim' : 'Não'}</td>
            <td>
            &nbsp;&nbsp;<a href="#Aqui" onClick={() => handleAlterClick (itens.id, 'A')}><SvgEdit/></a>
            &nbsp;&nbsp;<a href="#Aqui" onClick={() => handleDeleteClick (itens.id)}><SvgDelete/></a>
            </td>
          </tr>
        ))}
      </tbody>
    </table>

    {PopExcluir && (
        <div id ="PopExcluir" className="modal">
          <div className="modal-content">
            <h3>Excluir</h3>
            <p>Tem certeza de que deseja excluir este item?</p>
            <button className="botaovermelho" onClick={confirmDelete}>Excluir</button>
            <button className="botaocinza" onClick={cancelDelete}>Cancelar</button>
          </div>
        </div>
    )}

  {PopAlterar && (
        <div id = "PopAlterar" className="modal">
          <div className="modal-content">
            <h3>{titulo}</h3>
            <p>
              <FForm id={opcId} ai={opcAI}/>
            </p>
          </div>
          
        </div>
    )}
      <button class="botaocinsa"    onClick={() => {window.location.href = "./area"; }}><SvgSairMenu /><br/>Menu</button>&nbsp;
      <button class="botaocinsa"    onClick={() => handleIncluirClick ('', 'I')}><SvgNew2 /><br/>Incluir</button>&nbsp;
  </div>
);
}

export default AnuGrid;